import { createContext } from "react";

const BillingAccountContext = createContext();

export default BillingAccountContext;